// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/arrow-left-right.js';

import { paths } from '../generated/arrow-left-right';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('arrow-left-right', Original, paths);
